<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap>
				<app-card :fullBlock="true" colClasses="xs12">
					<v-container>
						<v-layout row wrap pa-3>
							<v-flex xs12>
								<router-link to="/stores">
									<i class="zmdi zmdi-long-arrow-left zmdi-hc-2x"></i>
								</router-link>
							</v-flex>
							<v-flex xs12>
								<h3>{{ $t("message.salesStatistics") }}</h3>
							</v-flex>

							<template v-if="user.store">
								<app-card
									:heading="$t('message.totalSales')"
									colClasses="md3 sm6 xs12"
									customClasses="social-share-wrap"
									>{{ $n(user.store.total_sales) }}</app-card
								>
								<app-card
									:heading="$t('message.totalVerifiedSales')"
									colClasses="md3 sm6 xs12"
									customClasses="social-share-wrap"
									>{{ $n(user.store.total_verified_sales) }}</app-card
								>
								<app-card
									:heading="$t('message.totalCustomers')"
									colClasses="md3 sm6 xs12"
									customClasses="social-share-wrap"
									>{{ $n(user.store.total_clients) }}</app-card
								>
								<app-card
									:heading="$t('message.customersWithBills')"
									colClasses="md3 sm6 xs12"
									customClasses="social-share-wrap"
									>{{ $n(user.store.clients_with_bills) }}</app-card
								>
							</template>
						</v-layout>

						<v-layout row wrap pa-3>
							<v-flex xs12>
								<h3>Membresia</h3>
							</v-flex>

							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.startDate')"
									v-model="user.store.created_at"
									readonly
								></v-text-field>
							</v-flex>
							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.expireDate')"
									v-model="user.store.subscription_finish_date"
									readonly
								></v-text-field>
							</v-flex>
						</v-layout>

						<v-layout row wrap px-3>
							<v-flex xs12>
								<h3>{{ $t("message.ownerName") }}</h3>
							</v-flex>
							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.name')"
									v-model="user.name"
									readonly
								></v-text-field>
							</v-flex>
							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.lastname')"
									v-model="user.lastname"
									readonly
								></v-text-field>
							</v-flex>
							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.email')"
									v-model="user.email"
									readonly
								></v-text-field>
							</v-flex>
						</v-layout>

						<v-layout row wrap px-3>
							<v-flex xs12>
								<h3>{{ $t("message.storeInformation") }}</h3>
							</v-flex>

							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.name')"
									v-model="user.store.name"
									readonly
								></v-text-field>
							</v-flex>

							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.description')"
									v-model="user.store.description"
									readonly
								></v-text-field>
							</v-flex>

							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.telegramUser')"
									v-model="user.store.telegram_user_bot"
									readonly
								></v-text-field>
							</v-flex>

							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.primaryUserAdministrator')"
									v-model="user.store.admin_telegram"
									readonly
								></v-text-field>
							</v-flex>

							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.telephone')"
									v-model="user.phone"
									readonly
								></v-text-field>
							</v-flex>

							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.telegramStore')"
									v-model="telegramStore"
									readonly
									append-icon="mdi-open-in-new"
									@click:append="goTo(telegramStore)"
								></v-text-field>
							</v-flex>

							<v-flex xs12 sm6>
								<v-text-field
									:label="$t('message.webStore')"
									v-model="webStore"
									readonly
									append-icon="mdi-open-in-new"
									@click:append="goTo(webStore)"
								></v-text-field>
							</v-flex>

							<v-layout row wrap px-3 v-if="address">
								<v-flex xs12>
									<h3>{{ $t("message.address") }}</h3>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.country')"
										v-model="address.country"
										readonly
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.state')"
										v-model="address.state"
										readonly
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.city')"
										v-model="address.city"
										readonly
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field
										:label="$t('message.address')"
										v-model="address.street_address"
										readonly
									></v-text-field>
								</v-flex>
							</v-layout>
						</v-layout>
					</v-container>
				</app-card>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { GET_USER } from "../../store/modules/users/actions.type";

export default {
	data() {
		return {
			user: {
				name: "",
				lastname: "",
				email: "",
				store: {
					total_sales: 0,
					total_verified_sales: 0,
					total_clients: 0,
					clients_with_bills: 0,
					name: "",
					phone: "",
					description: "",
					created_at: "",
					subscription_finish_date: "",
					telegram_user_bot: "",
					admin_telegram: "",
				},
			},
			address: {
				country: "Por setear",
				state: "Por setear",
				city: "Por setear",
				street_address: "Por setear",
			},
		};
	},
	created() {
		this.getUser();
	},
	computed: {
		/*user() {
      let user = null;
      const userId = this.$route.params.id;
      const userIndex = this.users.findIndex(element => element.id == userId);

      if (userIndex >= 0) {
        user = this.users[userIndex];
      }

      return user;
    }*/
		telegramStore() {
			return `t.me/${this.user.store.telegram_user_bot}`;
		},
    webStore() {
      return `store.tubotones.com/${this.user.store.web_store}`;
    }
	},
	methods: {
		goTo(link) {
			window.open(`https://${link}`);
		},
		getUser() {
			const userId = this.$route.params.id;
			this.$store
				.dispatch(GET_USER, userId)
				.then((res) => {
					let [user] = res;
					this.user = user;
					const { address } = user.store;

					if (address) this.address = address;
				})
				.catch((error) => {
					console.error(error);
				});
		},
	},
	filters: {
		formatDate(value) {
			return moment(value).format("YYYY-MM-DD");
		},
	},
};
</script>

<style></style>
